<template>
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
        width="18.698px" height="19.533px" viewBox="0 0 18.698 19.533" style="enable-background:new 0 0 18.698 19.533;"
        xml:space="preserve">
        <path fill="currentColor" d="M15.586,16.888c-0.183,0-0.368-0.069-0.509-0.21l-6.401-6.374C8.54,10.169,8.463,9.985,8.463,9.792
        c0-0.191,0.076-0.375,0.211-0.511l6.402-6.385c0.282-0.28,0.739-0.282,1.021,0.001c0.281,0.282,0.281,0.74-0.001,1.021
        l-5.889,5.874l5.888,5.862c0.283,0.281,0.285,0.739,0.003,1.021C15.957,16.817,15.772,16.888,15.586,16.888z"/>
        <path fill="currentColor" d="M9.413,16.888c-0.184,0-0.368-0.069-0.509-0.21l-6.401-6.374C2.366,10.169,2.29,9.985,2.29,9.792
        c0-0.191,0.076-0.375,0.212-0.511l6.402-6.385c0.282-0.28,0.739-0.282,1.021,0.001c0.281,0.282,0.281,0.74-0.001,1.021
        L4.035,9.792l5.887,5.862c0.284,0.281,0.285,0.739,0.003,1.021C9.784,16.817,9.599,16.888,9.413,16.888z"/>
    </svg>
</template>
